import { USER_PROPS } from "../constants/app";
import { userCollection } from "./firebase";
import { pick } from "@/utils";

/**
 * Fetches user profile details of logged in user
 */
export const getUserProfile = (email) => {
  return userCollection.doc(email);
};

/**
 * Creates a user profile record in users collection
 */
export const createUserProfile = ({ email, ...data }) => {
  const payload = pick(data, USER_PROPS);
  return userCollection.doc(email).set(payload);
};
